<template>
    <div class="relative">
        <div class="relative w-16 h-16">
            <div ref="pulse" class="absolute inset-0 w-full h-full border border-aqua-500 rounded-full"></div>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {
        gsap.fromTo(
            this.$refs.pulse,
            { opacity: 1, scale: 0.1 },
            { duration: 0.75, opacity: 0, scale: 1, repeat: -1, ease: 'circ.out' }
        );
    }
};
</script>
